import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import LoginPage from './pages/Login/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import RoleRoute from './components/RoleRoute';
import HomePage from './pages/Home/HomePage';
import LogsPage from './pages/Logs/LogsPage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import PlanesPage from './pages/Planes/PlanesPage';
import CalculadoraPage from './pages/Calculadora/CalculadoraPage';
import AltasPage from './pages/Altas/AltasPage';
import SeguimientoAltasPage from './pages/Altas/SeguimientoAltasPage';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <RoleRoute allowedRoles={['admin', 'manager']}>
                <DashboardPage />
              </RoleRoute>
            }
          />
          <Route
            path="/calculadora"
            element={
              <RoleRoute allowedRoles={['admin', 'manager']}>
                <CalculadoraPage />
              </RoleRoute>
            }
          />
          <Route
            path="/altas"
            element={
              <RoleRoute allowedRoles={['admin', 'manager']}>
                <AltasPage />
              </RoleRoute>
            }
          />
          <Route
            path="/altas/seguimiento"
            element={
              <RoleRoute allowedRoles={['admin', 'manager']}>
                <SeguimientoAltasPage />
              </RoleRoute>
            }
          />
          <Route
            path="/logs"
            element={
              <AdminRoute>
                <LogsPage />
              </AdminRoute>
            }
          />
          <Route
            path="/planes"
            element={
              <ProtectedRoute>
                <PlanesPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
